// Shared constants for the Data Partnerships landing page (Program 2:
// a business monetizes the workflows it already runs).
// The first step is a short partnerships call, not a self-serve signup.
export const DP_PRIMARY_CTA_HREF = "https://cal.com/jack-terac/15min";
export const DP_HOW_ANCHOR = "#how-it-works";
export const DP_PARTNERSHIPS_EMAIL = "partnerships@terac.com";
